import { AbilityBuilder, createMongoAbility } from '@casl/ability';
import { permissionSystem } from '@arc/shared/util-permissions';
export function defineFallbackAbility() {
  const builder = new AbilityBuilder(createMongoAbility);
  return builder.build();
}
export function defineAbilityFor(user) {
  if (!user) {
    return defineFallbackAbility();
  }
  const builder = new AbilityBuilder(createMongoAbility);

  // do high level permissions
  for (const permissionType of permissionSystem.permissionTypes) {
    for (const actionType of permissionSystem.actionTypes) {
      if (user.permissions?.[permissionType]?.[actionType]) {
        // can('create', 'User')
        builder.can(actionType, permissionType);
      }
    }
  }
  builder.cannot('update', 'User', 'superuser', {
    id: user.id
  });
  return builder.build();
}